// extracted by mini-css-extract-plugin
module.exports = {"container":"contact__container","textContainer":"contact__textContainer","postcode":"contact__postcode"};